module.exports = __webpack_public_path__ + "static/media/vivi-sorrindo-esquerda.0883e795.svg";